/* Kawaii Club's "Join free" (sections/kc-club.liquid). The button is
   Shopify's account component (<shopify-account>), which opens Shopify's
   sign-in and sign-up sheet over the page. Once on the page it fetches its
   sign-in code and Shop's sign-in frame straight away, which slowed the
   rest of the page's loading, so it waits in a <template> with a plain
   sign-in link in its place. It goes in when the club comes into view
   (after the page has loaded) or a pointer or finger reaches for the link;
   CSS then swaps the link for the component's own button, which looks the
   same. A click that beats it opens the sheet once the component is
   ready, or follows the link if it never gets there. */
(() => {
  if (window.kcClubJoin) return;
  window.kcClubJoin = true;

  const WAIT = 5000;

  const stamp = (link) => {
    if (link.kcAccount) return link.kcAccount;
    const template = link.parentElement && link.parentElement.querySelector('template[data-kc-join-tpl]');
    if (!template) return null;
    const hadFocus = document.activeElement === link;
    const content = document.importNode(template.content, true);
    const account = content.querySelector('shopify-account');
    template.replaceWith(content);
    link.kcAccount = account;

    // A keyboard user on the link goes on to the component's button (the
    // documented signed-out-avatar part) once the link is hidden.
    if (hadFocus && account) {
      customElements.whenDefined('shopify-account').then(() => {
        let tries = 0;
        const next = () => {
          const button = account.shadowRoot && account.shadowRoot.querySelector('[part~="signed-out-avatar"]');
          if (button) button.focus();
          else if (++tries < 20) requestAnimationFrame(next);
        };
        requestAnimationFrame(next);
      });
    }
    return account;
  };

  const open = (link) => {
    const account = stamp(link);
    if (!account) {
      window.location.href = link.href;
      return;
    }
    link.setAttribute('aria-busy', 'true');
    const late = new Promise((resolve) => setTimeout(resolve, WAIT, false));
    Promise.race([customElements.whenDefined('shopify-account').then(() => true), late]).then((ready) => {
      link.removeAttribute('aria-busy');
      if (ready && typeof account.showModal === 'function') account.showModal();
      else window.location.href = link.href;
    });
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[data-kc-join]');
    if (!link) return;
    event.preventDefault();
    open(link);
  });

  const reach = (event) => {
    const link = event.target.closest && event.target.closest('a[data-kc-join]');
    if (link) stamp(link);
  };
  document.addEventListener('pointerover', reach, { passive: true });
  document.addEventListener('touchstart', reach, { passive: true });

  const watch = () => {
    const links = document.querySelectorAll('a[data-kc-join]');
    if (!links.length || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        stamp(entry.target);
      });
    });
    links.forEach((link) => observer.observe(link));
  };
  if (document.readyState === 'complete') watch();
  else window.addEventListener('load', watch, { once: true });
})();
